import { InputField } from '@zoopla-eng/zds/input-field';

export type Keywords = string;

type KeywordsProps = {
    value: Keywords;
    onChange: (keywords: Keywords) => void;
};

export const Keywords = ({ value, onChange }: KeywordsProps) => {
    return (
        <InputField
            autoComplete="off"
            name="keywords"
            label="Keywords"
            helpText="Search for phrases by using quotations marks e.g. “double garage”, or exclude terms by prefixing them with a minus sign e.g. -studio."
            placeholder='e.g. conservatory or "double garage"'
            value={value}
            onChange={(e) => {
                onChange(e.target.value);
            }}
        />
    );
};
